function condition (conditionFunc) {
  if (!arguments.length) return this.__execs__.condition;
  this.__execs__.condition = conditionFunc.call(this, this.__attrs__.dimensions, this.__attrs__.measures);
  return this;//throw exports.conditionException(); error 처리
}

export default condition;


// WEBPACK FOOTER //
// ./layouts/default/condition.js